module.exports = __webpack_public_path__ + "img/banner-1.51ac2035.jpg";